import { render, staticRenderFns } from "./TermsOfServiceSpanish.vue?vue&type=template&id=bce3ca10"
import script from "./TermsOfServiceSpanish.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceSpanish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports